// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../textstyles/fonts.css";
import "../reset.css";
import "./Input.css";
import React, { createContext, useContext } from "react";
import {
  exists,
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../_internal_utils";
import {
  SpacerPrimitive,
  TextPrimitive,
  ContainerPrimitive,
} from "../_internal_primitives";
import { Root, TextFieldPrimitive } from "../_internal_text_field";

const styles = [
  {
    type: "default",
    layers: {
      input: {
        none: {
          "placeholder-text": "Placeholder",
        },
      },
      "5g7TB5hmXU": {
        none: {
          text: "Label",
        },
      },
      RpvVtLAE7b: {
        none: {
          text: "unit",
        },
      },
    },
  },
  {
    type: "boolean",
    propName: "handleOnKeyDown",
    layers: {},
  },
  {
    type: "boolean",
    propName: "required",
    layers: {},
  },
  {
    type: "enum",
    propName: "withUnit",
    values: [
      {
        propValue: "left",
        layers: {
          input: {
            none: {
              "placeholder-text": "0.00",
            },
          },
          RpvVtLAE7b: {
            none: {
              text: "$",
            },
          },
        },
      },
      {
        propValue: "right",
        layers: {
          input: {
            none: {
              "placeholder-text": "1",
            },
          },
        },
      },
    ],
  },
  {
    type: "boolean",
    propName: "darkPlaceholder",
    layers: {},
  },
  {
    type: "enum",
    propName: "validationType",
    values: [
      {
        propValue: "invalid",
        layers: {},
      },
      {
        propValue: "required",
        layers: {},
      },
      {
        propValue: "valid",
        layers: {},
      },
    ],
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
  {
    type: "boolean",
    propName: "handleOnKeyDown",
    layers: {},
  },
  {
    type: "boolean",
    propName: "required",
    layers: {},
  },
  {
    type: "enum",
    propName: "withUnit",
    values: [
      {
        propValue: "left",
        layers: {},
      },
      {
        propValue: "right",
        layers: {},
      },
    ],
  },
  {
    type: "boolean",
    propName: "darkPlaceholder",
    layers: {},
  },
  {
    type: "enum",
    propName: "validationType",
    values: [
      {
        propValue: "invalid",
        layers: {},
      },
      {
        propValue: "required",
        layers: {},
      },
      {
        propValue: "valid",
        layers: {},
      },
    ],
  },
];

const variantPropTypes = [
  {
    type: "boolean",
    propName: "handleOnKeyDown",
  },
  {
    type: "boolean",
    propName: "required",
  },
  {
    type: "enum",
    propName: "withUnit",
    propValues: ["left", "right"],
  },
  {
    type: "boolean",
    propName: "darkPlaceholder",
  },
  {
    type: "enum",
    propName: "validationType",
    propValues: ["invalid", "required", "valid"],
  },
];

export const InputContext = createContext(null);

function Input(_props) {
  const defaults = useContext(InputContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <Root
      {...props}
      key="root"
      addSpacing={false}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "root",
        scope: "Vy3ZnEcVmj",
        activeVariants: activeVariants,
      }}
    >
      {(getStyle) => (
        <>
          <ContainerPrimitive
            id={"Container_N2g1KqYu1r"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_Vy3ZnEcVmj_N2g1KqYu1r"
            }
            key={"N2g1KqYu1r"}
            addSpacing={false}
            element={getStyle("N2g1KqYu1r", "htmlElement")}
          >
            <ContainerPrimitive
              id={"label_Rxh7LBquzR"}
              className={
                "__visly_reset_7X7HTLRqyD __visly_scope_Vy3ZnEcVmj_Rxh7LBquzR"
              }
              key={"Rxh7LBquzR"}
              addSpacing={false}
              element={getStyle("Rxh7LBquzR", "htmlElement")}
            >
              {
                <TextPrimitive
                  id={"Label_5g7TB5hmXU"}
                  className={
                    "__visly_reset_7X7HTLRqyD __visly_scope_Vy3ZnEcVmj_5g7TB5hmXU"
                  }
                  key={"5g7TB5hmXU"}
                  text={
                    exists(props.label)
                      ? props.label
                      : getStyle("5g7TB5hmXU", "text")
                  }
                  element={getStyle("5g7TB5hmXU", "htmlElement")}
                />
              }
            </ContainerPrimitive>
            <ContainerPrimitive
              id={"input-container_5kzWNAcw2H"}
              className={
                "__visly_reset_7X7HTLRqyD __visly_scope_Vy3ZnEcVmj_5kzWNAcw2H"
              }
              key={"5kzWNAcw2H"}
              addSpacing={false}
              element={getStyle("5kzWNAcw2H", "htmlElement")}
            >
              <TextPrimitive
                id={"unit_RpvVtLAE7b"}
                className={
                  "__visly_reset_7X7HTLRqyD __visly_scope_Vy3ZnEcVmj_RpvVtLAE7b"
                }
                key={"RpvVtLAE7b"}
                text={
                  exists(props.unit)
                    ? props.unit
                    : getStyle("RpvVtLAE7b", "text")
                }
                element={getStyle("RpvVtLAE7b", "htmlElement")}
              />
              <SpacerPrimitive
                id={"Spacer_X5tcCNxjqK"}
                className={
                  "__visly_reset_7X7HTLRqyD __visly_scope_Vy3ZnEcVmj_X5tcCNxjqK"
                }
                key={"X5tcCNxjqK"}
              />
              <TextFieldPrimitive
                id={"input_input"}
                className={
                  "__visly_reset_7X7HTLRqyD __visly_scope_Vy3ZnEcVmj_input"
                }
                key={"input"}
                placeholder={
                  exists(props.placeholder)
                    ? props.placeholder
                    : getStyle("input", "placeholder-text")
                }
              />
            </ContainerPrimitive>
          </ContainerPrimitive>
          <ContainerPrimitive
            key={"9xDTnSYTvg"}
            id={"Slot_9xDTnSYTvg"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_Vy3ZnEcVmj_9xDTnSYTvg"
            }
            addSpacing={false}
          >
            {props.validAnimation}
          </ContainerPrimitive>
        </>
      )}
    </Root>
  );
}

Input.__variants = [
  {
    name: "handleOnKeyDown",
    type: "variant",
  },
  {
    name: "required",
    type: "variant",
  },
  {
    name: "withUnit",
    type: "group",
    variants: ["left", "right"],
  },
  {
    name: "darkPlaceholder",
    type: "variant",
  },
  {
    name: "validationType",
    type: "group",
    variants: ["invalid", "required", "valid"],
  },
];

export default Input;
